import { flatsPriceHidden } from '../../constant/flatsPriceHidden';

const getFlatsWithProperties = flats => {
  if (!flats) return null;

  return flats
    .map(flat => {
      let flatName = flat.lokal_str.includes('AA')
        ? flat.lokal_str.replace('AA', 'A.')
        : flat.lokal_str.replace('BB', 'B');
      
      flatName = flatName.replace(/^([AB])MP/, '$1');

      return {
        investment: flat.investments_name
          .replace(' ABC', '')
          .replace(' AB', '')
          .replace(' E', ''),
        name: flatName,
        price: Math.floor(Number(flat.price)),
        type: flat.investments_type,
        isPriceVisible: flatsPriceHidden.includes(flatName) ? 1 : 0,
        area: Number(flat.area_flat).toFixed(2),
        floor: flat.investments_floor,
        rooms: flat.investments_rooms,
        balcony:
          (flat.area_balcony && Number(flat.area_balcony).toFixed(2)) || null,
        status: Number(flat.status_id),
        building: flat.building,
        PNG: flat.png,
        PDF: flat.pdf,
        isPromo: false,
      };
    })
    .filter(flat => !flat.name.includes('C'));
};

export default getFlatsWithProperties;
